<script setup lang="ts">
  import TheNavbarLower from './the-navbar-lower.vue'
  import TheNavbarUpper from './the-navbar-upper.vue'
</script>

<template>
  <div class="h-72px lg:h-154px sm:h-72px">
    <the-navbar-upper />

    <the-navbar-lower />
  </div>
</template>
